module.exports = require('./dist/index')



//////////////////
// WEBPACK FOOTER
// ./~/vue-cli-plugin-apollo/graphql-client/index.js
// module id = 796
// module chunks = 0